import React, { useState } from 'react';
import { Section, Card } from './Shared';
import { BadgeCheckIcon, ChevronDown } from 'lucide-react';
export const TrustAndFAQ = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para mi especialidad dentro de la estética?',
    a: 'Sí. Está diseñado para cualquier profesional del rubro: manicuristas, lashistas, brow artists, cosmetólogas, esteticistas, peluqueras y especialistas en skincare. El sistema de ventas, contenido y fidelización funciona igual para todas las especialidades.'
  }, {
    q: '¿Es un curso grabado?',
    a: 'No. Es un sistema en PDF descargable: abrís el tomo que necesitás, copiás, aplicás y listo. No tenés que mirar clases ni “cursar” nada.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Después del pago recibís el acceso de inmediato por email o plataforma. Todo queda disponible en PDF para usar desde celular, tablet o computadora.'
  }, {
    q: '¿Qué pasa si no sé nada de marketing o redes?',
    a: 'Está pensado para empezar desde cero. Tenés scripts, guiones y ejemplos del rubro listos para copiar y pegar; no necesitás conocimientos previos.'
  }, {
    q: '¿Por qué es mejor que buscar cosas gratis en Google?',
    a: 'Lo gratis suele estar disperso y ser genérico. Acá tenés un sistema ordenado, completo y creado para profesionales de estética en Argentina.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para probarlo. Si no es lo que esperabas, pedís la devolución del 100% sin preguntas ni formularios.'
  }, {
    q: '¿Cómo pago por Mercado Pago y cuándo recibo el acceso?',
    a: 'El pago se completa de forma segura en Mercado Pago. Apenas se acredita, recibís el acceso automático por email o plataforma; las cuotas disponibles dependen de lo que Mercado Pago muestre para tu tarjeta en el checkout.'
  }];
  return <>
      {/* Testimonials Grid */}
      <Section bg="base" data-id="element-384" data-mp="2f5ilt65gj8t0">
        <div className="text-center mb-12" data-id="element-385" data-mp="2f50jpsw460d6">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark" data-id="element-386" data-mp="2f35wg7xddw5x">
            ❤️ Ellas ya tienen el sistema
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-387" data-mp="265dgr2nqkmi0">
          <Card className="bg-white" data-id="element-388" data-mp="2a5nvb3plgl8h">
            <div className="mb-4 text-brand" data-id="element-389" data-mp="2a6p75aefpbr9">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-390" data-mp="2xw01oa56y9wy">
              "El Planner me hizo mirar mi negocio con otros ojos. Ahora sé
              cuánto entra, cuánto sale y qué meta tengo que cumplir cada mes."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-391" data-mp="2ouk0mt09nk5e">
              — Daniela C. · 📍 Salta · Manicurista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-392" data-mp="1dg6fhvwwdit2">
            <div className="mb-4 text-brand" data-id="element-393" data-mp="1df3sw06ly2iy">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-394" data-mp="1ieq5q8iixgr8">
              "Usé uno de los guiones de Reels y me animé a publicar sin pensar
              tanto. Esa misma semana llegaron consultas que sí terminaron en turnos."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-395" data-mp="15vuka95xe7uy">
              — Micaela A. · 📍 Neuquén · Lashista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-396" data-mp="1ewkbezk8ra2c">
            <div className="mb-4 text-brand" data-id="element-397" data-mp="1exlk4xdsbkgw">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-398" data-mp="r6ybg9w1oqta">
              "Subí los precios. No perdí ninguna clienta. Las que se fueron
              eran las que nunca valoraban mi trabajo igual."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-399" data-mp="10ycf8tv14cs8">
              — Marcela S. · 📍 Rosario · Esteticista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-400" data-mp="8h045w02n1qp">
            <div className="mb-4 text-brand" data-id="element-401" data-mp="8fyiyypccyv9">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-402" data-mp="3hwzico06xj9">
              "Mis historias ahora tienen intención. Con el sistema sé qué mostrar y qué decir para que me pregunten por turnos de verdad."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-403" data-mp="37u7o0geyr0co">
              — Rocío V. · 📍 CABA · Esteticista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-404" data-mp="3buhudu6o3ss2">
            <div className="mb-4 text-brand" data-id="element-405" data-mp="3gnui823ivvjr">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-406" data-mp="3gpfb7na6v6fi">
              "Recuperé 7 clientas que daba por perdidas con la Máquina de
              Re-Agendamiento. No lo podía creer."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-407" data-mp="3qnbmcf34m1dm">
              — Antonella R. · 📍 Tucumán · Brow Artist
            </p>
          </Card>
          <Card className="bg-white" data-id="element-408" data-mp="3fhoiref1qyf">
            <div className="mb-4 text-brand" data-id="element-409" data-mp="3eg9kbua4kbf">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-410" data-mp="217vnptmtvy1z">
              "El Protocolo de Cancelaciones me ahorra peleas y dinero todos los
              meses. Antes perdía turnos sin decir nada."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-411" data-mp="1xpxyhqeffsdq">
              — Sofía B. · 📍 La Plata · Peluquera
            </p>
          </Card>
        </div>
      </Section>

      {/* Guarantee Section */}
      <Section bg="base" className="border-t border-gray-200" data-id="element-412" data-mp="1nwh0ea79br49">
        <div className="max-w-3xl mx-auto text-center" data-id="element-413" data-mp="1jyt3j1m07o9q">
          <div className="relative inline-flex h-36 w-36 items-center justify-center rounded-full bg-brand p-2 mb-7 shadow-[0_12px_28px_rgba(201,168,124,0.28)]" data-id="element-414" data-mp="2gn8wz8s8ihs4">
            <div className="flex h-full w-full flex-col items-center justify-center rounded-full border-2 border-dark/80 text-dark" data-id="element-415" data-mp="2bmbcgpjr5bng">
              <BadgeCheckIcon className="h-7 w-7 mb-1" aria-hidden="true" data-id="element-416" data-mp="22nzneryjalx4" />
              <span className="font-montserrat text-[10px] font-bold uppercase tracking-[0.18em]" data-id="element-417" data-mp="22q2c98nya909">Garantía</span>
              <span className="font-playfair text-2xl font-bold leading-none" data-id="element-418" data-mp="r8kkz8nk31um">Cero Riesgo</span>
            </div>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-4" data-id="element-419" data-mp="spggniwrtpgk">
            GARANTÍA 7 DÍAS
          </h2>
          <p className="font-montserrat text-xl text-brand font-bold mb-8" data-id="element-420" data-mp="xoazulynhg17">
            Claridad, acompañamiento y tranquilidad.
          </p>

          <div className="font-montserrat text-lg text-gray-700 space-y-4 mb-8" data-id="element-421" data-mp="nqd99rtbj75f">
            <p data-id="element-422" data-mp="nshoh5wo3sl0">
              Abrís el Megakit y lo aplicás en tu negocio. Durante 7 días tenés espacio para conocer cada herramienta a tu ritmo.
            </p>
            <p className="font-bold text-2xl text-dark" data-id="element-423" data-mp="eqqgfuenn9nz">Devolución del 100%.</p>
            <p data-id="element-424" data-mp="23sx5evjblo">Proceso simple: escribinos y te acompañamos con claridad.</p>
            <p data-id="element-425" data-mp="4zvu6q1esa2j">El riesgo es cero. La decisión es tuya.</p>
          </div>

          <div className="bg-mid p-6 rounded-xl border border-gray-200" data-id="element-426" data-mp="4xsv7gia36lo">
            <p className="font-montserrat text-sm text-gray-600" data-id="element-427" data-mp="3n6a84ozogk0x">
              <strong data-id="element-428" data-mp="3s54qxqxna8l1">Tasa de devoluciones: menos del 1%.</strong> Las que lo
              abren, lo usan. Las que lo usan, no vuelven atrás.
            </p>
          </div>
        </div>
      </Section>

      {/* FAQ Section */}
      <Section bg="mid" data-id="element-429" data-mp="33ljftai76t5v">
        <div className="max-w-3xl mx-auto" data-id="element-430" data-mp="33mbcyprg0yy9">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark text-center mb-12" data-id="element-431" data-mp="3hjzvvs1y9w0o">
            ❓ Lo que más preguntan
          </h2>

          <div className="space-y-4" data-id="element-432" data-mp="3dk8wx129s9l2">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-433" data-mp="3rg2yt04mlyoo" data-mpi={index}>
                <button className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" onClick={() => setOpenFaq(openFaq === index ? null : index)} data-id="element-434" data-mp="52m9r6xbsdw0">
                  <span className="font-montserrat font-bold text-dark pr-4" data-id="element-435" data-mp="e3kexsji2rg6">
                    ▸ {faq.q}
                  </span>
                  <ChevronDown className={`text-brand transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} size={20} data-id="element-436" data-mp="923jwdnp5z7i" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-437" data-mp="1pgk2vglommt3">
                  <p className="font-montserrat text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-438" data-mp="xqp0ai8td0mh">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </Section>
    </>;
};